import InsideHeaderMenu from './views/main.c';
export default InsideHeaderMenu;
